import { iSubRoute } from "../../../definitions/interfaces"

export function getAssetRoutes({ urlPrefix = "" }) {
  return routes.map((r) => ({ ...r, route: urlPrefix + r.route }))
}

const routes: iSubRoute[] = [
  {
    title: "Overview",
    route: "",
  },
]
